import Box from '@mui/material/Box';
import React from 'react';
import ConstructionIcon from '@mui/icons-material/Construction';

function MaintenancePage() {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          maxWidth: '500px',
          margin: 'auto',
          textAlign: 'center',
        }}
      >
        <ConstructionIcon
          sx={{
            fontSize: '5rem',
            marginBottom: '16px',
          }}
        />
        <Box sx={{ mb: 2 }}>Midi Sandbox is undergoing maintenance.</Box>
      </Box>
    </Box>
  );
}

export default MaintenancePage;
